import { periodTypeOptions } from '../models'

export const periodTypeTransfer = (toLabel = true, input) => {
  return (
    toLabel
      ? periodTypeOptions.find(el => el.value === input).label
      : periodTypeOptions.find(el => el.label === input).value
  )
}
